<template>
	<div v-if="isUserAllowedInLevel5or6 && isAppContainer" class="flex-grow flex flex-col">
		<ProcessCreateOrderDocumentationOverviewImage
			v-show="pageIndex === pageIndexEnum.ProcessCreateOrderDocumentationOverviewImage"
			@next="next"
			@previous="previous"
		/>
		<ProcessCreateOrderDocumentationOrderType
			v-show="pageIndex === pageIndexEnum.ProcessCreateOrderDocumentationOrderType"
			@next="next"
			@previous="previous"
		/>
		<ProcessCreateOrderFinish v-if="pageIndex === pageIndexEnum.ProcessCreateOrderFinish" @next="next" @previous="previous" />
	</div>
	<Forbidden v-else />
</template>

<script>
import ProcessCreateOrderDocumentationOverviewImage from '@/views/management/Process/OrderDocumentation/ProcessCreateOrderDocumentationOverviewImage';
import ProcessCreateOrderDocumentationOrderType from '@/views/management/Process/OrderDocumentation/ProcessCreateOrderDocumentationOrderType';
import ProcessCreateOrderFinish from '@/views/management/Process/OrderDocumentation/ProcessCreateOrderFinish';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'ProcessCreateOrderDocumentation',
	components: { Forbidden, ProcessCreateOrderFinish, ProcessCreateOrderDocumentationOrderType, ProcessCreateOrderDocumentationOverviewImage },
	mixins: [Authentication, AppContainerMixin],
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAppContainer) {
			this.$store.commit('clearProcessCreateOrderDocumentation');
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			this.$store.commit('setProcessCreateOrderDocumentationCustomer', { id: this.$route.query.customer_id });
			this.$store.commit('setProcessCreateOrderDocumentationVehicle', { id: this.$route.query.vehicle_id });
		}
	},
	methods: {
		next(args) {
			this.pageIndex = this.pageRegister[++this.pageRegisterIndex];
		},
		previous() {
			const index = this.pageRegister[--this.pageRegisterIndex];
			if (index || index === 0) {
				this.pageIndex = index;
			} else {
				this.$router.push(this.$route.params.backlink);
			}
		},
	},
	watch: {
		pageIndex: function() {
			this.$emit('scrollUp', this.pageIndex);
		},
	},
	data() {
		return {
			pageRegisterIndex: 0,
			pageIndex: 0,
			pageIndexEnum: {
				ProcessCreateOrderDocumentationOverviewImage: 0,
				ProcessCreateOrderDocumentationOrderType: 1,
				ProcessCreateOrderFinish: 2,
			},
		};
	},
	computed: {
		pageRegister() {
			return [
				this.pageIndexEnum.ProcessCreateOrderDocumentationOverviewImage,
				this.pageIndexEnum.ProcessCreateOrderDocumentationOrderType,
				this.pageIndexEnum.ProcessCreateOrderFinish,
			];
		},
	},
};
</script>
